<template>
  <div>
    <div class="page8 page landscape">
      <Logo />
      <div class="flex">
        <div class="info">
          <div class="container">
            <center><h1>Jak tworzymy treści?</h1></center>
            <h4>
              Aby poprawić ruch na twojej stronie niezbędny jest Audyt SEO
            </h4>
            <ul>
              <li>
                Analizujemy potencjał treści za pomocą narzędzi SEO i CM
                (BuzzSumo, Ahrefs, SurferSEO , Senuto , Answerthepublic, Planner
                Słów Kluczowych
              </li>
              <li>
                Przygotowujemy harmonogram (a w nim tytuł, streszczenie,
                wytyczne webwritingowe)
              </li>
              <li>
                Znawców danej tematyki, dobrani na stałe do projektu, piszą
                treści
              </li>
              <li>
                Artykuły są poprawiane językowo i stylistycznie przez
                doświadczonych Edytorów
              </li>
              <li>
                Specjaliści ds. Content Marketingu poddają treści edycji
                webwritingowej
              </li>
              <li>
                Specjaliści SEO na bieżąco optymalizują artykuły pod kątem SEO i
                publikują je
              </li>
            </ul>
            <h4>Jaki jest rekomendowany zakres współpracy?</h4>
            <p>
              Co najmniej 5 artykułów o długości 5000 znaków ze spacjami
              miesięcznie
            </p>
          </div>
        </div>
        <div class="bg-image">
          <img src="/col8.jpg" alt="" srcset="" />
          <div class="overlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Seo8',
  components: {
    Logo,
  },
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page8 {
  color: #000 !important;
  text-align: left;
}

.container {
  margin-top: 100px;
}
</style>
